import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "candidatesPanel",
    "candidatesList",
    "candidateCard",
    "isinInput",
    "searchResult",
    "confirmPanel",
    "confirmSubtitle",
    "confirmName",
    "confirmIsin"
  ]

  selectCandidate(event) {
    const card = event.currentTarget

    this.candidateCardTargets.forEach((candidate) => {
      candidate.classList.toggle("is-selected", candidate === card)
    })
  }

  searchIsin(event) {
    event.preventDefault()
    const isin = this.isinInputTarget.value.trim()
    if (isin.length < 4) return

    this.searchResultTarget.innerHTML = "<p class=\"aia-note\">Recherche en cours...</p>"

    const url = `${this.data.get("share-search-url")}&isin=${encodeURIComponent(isin)}&position=${this.candidateCardTargets.length}`
    fetch(url, { method: "GET", headers: { "Accept": "application/json" } }).then((response) => {
      if (!response.ok) return response.json().then((data) => Promise.reject(data))
      return response.json()
    }).then((data) => {
      this.lastSearch = data
      this.searchResultTarget.innerHTML = data.result_html
    }).catch((error) => {
      this.lastSearch = null
      this.searchResultTarget.innerHTML = `<p class="aia-note is-error">${(error && error.error) || "Recherche impossible."}</p>`
    })
  }

  openConfirmation(event) {
    const card = event.currentTarget.closest(".aia-candidate-card")
    if (!card) return

    this.selectedCandidate = {
      share_id: card.dataset.shareId,
      share_name: card.dataset.shareName,
      isin: card.dataset.isin,
      score: card.dataset.score
    }

    this.confirmSubtitleTarget.textContent = `${this.selectedCandidate.share_name} a été sélectionné comme substitut.`
    this.confirmNameTarget.textContent = this.selectedCandidate.share_name
    this.confirmIsinTarget.textContent = this.selectedCandidate.isin
    this.candidatesPanelTarget.hidden = true
    this.confirmPanelTarget.hidden = false
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  backToCandidates() {
    this.confirmPanelTarget.hidden = true
    this.candidatesPanelTarget.hidden = false
  }

  confirmSubstitution() {
    if (!this.selectedCandidate) return

    fetch(this.data.get("confirm-url"), {
      method: "POST",
      headers: this.jsonHeaders(),
      body: JSON.stringify(this.selectedCandidate)
    }).then((response) => {
      if (!response.ok) return response.json().then((data) => Promise.reject(data))
      return response.json()
    }).then((data) => {
      window.location.href = data.redirect_url
    }).catch((error) => {
      if (error && error.error) window.alert(error.error)
    })
  }

  addManualCandidate() {
    if (!this.lastSearch || !this.lastSearch.available || !this.lastSearch.card_html) return

    this.candidatesListTarget.insertAdjacentHTML("beforeend", this.lastSearch.card_html)
    this.searchResultTarget.innerHTML = ""
    this.isinInputTarget.value = ""
    this.lastSearch = null
  }

  jsonHeaders() {
    return {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
    }
  }
}
